import React from 'react'
import PropTypes from 'prop-types';
import {Col, Row, Panel, FormGroup, FormControl, Button} from 'react-bootstrap'

import './styles.css'

const SimpleSearchComponent = (props) => {
  const doSearch = (e) => {
    if (e.key === 'Enter') {
      props.onSearch();
    }
  };

  return (
    <Panel className="simple-filter">
      <Row>
        <Col md={8}>
          <FormGroup>
            <FormControl onChange={props.onInputChange}
                         onKeyPress={doSearch}
                         placeholder={props.placeholder}
                         value={props.searchValue}/>
          </FormGroup>
        </Col>
        <Col md={4} className="actions">
          <Button className="red-ghost-btn"
                  onClick={props.onSearch}>Search</Button>

          <Button className="red-ghost-btn"
                  onClick={props.onClear}>Clear search</Button>
        </Col>
      </Row>
    </Panel>
  );
};

SimpleSearchComponent.propTypes = {
  searchValue: PropTypes.string.isRequired,
  onSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onInputChange: PropTypes.func,
  placeholder: PropTypes.string,
};

SimpleSearchComponent.defaultProps = {
  placeholder: 'Search...'
};

export default SimpleSearchComponent;


// WEBPACK FOOTER //
// ./src/components/common/search/simple-search-component.jsx